<div *ngIf="inited"class="height100p flex-col">
    <sm-toolbar class="flex-item-fixed">
        <button pButton icon="fas fa-save" label="Speichern" [disabled]="!isChanged()" (click)="save()">
        </button>
        <p-dropdown [styleClass]="'width100'" id="gradeLevel" [options]="gradeLevels"
            [(ngModel)]="selectedGradeLevel" (onChange)="gradeLevelChanged()">
        </p-dropdown>
    </sm-toolbar>
    <sm-table2 class="flex-item-fill" [data]="table">
    </sm-table2>
</div>
